import pixel from "../../../../src/images/neograft-machine.png";
import hair from "../../../../src/images/four-hair.jpg";
import head from "../../../../src/images/four-head.jpg";
import * as React from 'react';
export default {
  pixel,
  hair,
  head,
  React
};